export interface RtsRequest {
    latitude: number;
    longitude: number;
    storeName?: string;
    selectedEmail: string;
    scannedData : Array<RtsScannedDataReq>;
  }
  
export interface RtsScannedDataReq {
    uuid : string,  
    id ?:  number, 
    barcode ?: string,
    scanSource : ScanSource,
    imageUrl ?: string,
    scannedTimestamp : string,
    scannedLocalTime?: string,
    eventTypeId : number,
    success? : boolean,
    reason? : string,
    otherReason?: string,
}

export interface RtsScannedDataResponse {

  id ?:  number, 
  barcode ?: string,
  scanSource : ScanSource,
  imageUrl ?: string,
  scannedTimestamp : string,
  scannedLocalTime?: string,
  eventTypeId : number,
  success? : boolean,
  reason? : string
}




export enum ScanSource {
   Manual = 'manual',
   BarcodeScan = 'barcode_scan',
   ImageUpload = "image_upload"
  }

export interface GeofenceRequest {
  latitude : number, 
  longitude : number,
  fenced ?: boolean,
  storeId? : string
}

